// ProjectNew K28 onayındaki "Sektör paketinden set kur" bağlantısı (TODO-KPI-141): Veri Yönetimi
// Set kur penceresini müşteri ön-seçili açar (`?clientId=&fork=1`). Sihirbaz durumu kaybolmasın
// diye yeni sekmede açılır. Yalnız Veri Yönetimi yetkisi (`kpi.manage`) olana görünür.

import { Link } from "react-router-dom";
import { KPI_PACKAGES_COPY } from "../../lib/kpi-packages-copy";
import { useAuthStore } from "../../stores/auth-store";

export function KpiSetPackageLinkView(props: { clientId: string }): JSX.Element {
  return (
    <Link
      to={`/clients/kpi/setler?clientId=${encodeURIComponent(props.clientId)}&fork=1`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="project-new-fork-link"
      style={{ color: "var(--color-primary-text)", fontWeight: 600, textDecoration: "underline" }}
    >
      {KPI_PACKAGES_COPY.projectNew.forkFromPackage}
    </Link>
  );
}

export function KpiSetPackageLink(props: { clientId: string }): JSX.Element | null {
  const canManage = useAuthStore((s) => s.user?.permissions["kpi.manage"] === true);
  if (!canManage || props.clientId === "") return null;
  return <KpiSetPackageLinkView clientId={props.clientId} />;
}
